import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { showUrlDokumen } from "stores/Pengajuan/function";

function Step6() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;
  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);

  const handleClickPdf = (url) => {
    dispatch({
      type: "PREVIEW_DOKUMEN",
      data: showUrlDokumen(dispatch, { urlImage: url }),
    });
  };

  React.useEffect(() => {
    let tmp = [];
    Object.entries(valDetail).forEach(([key, value]) => {
      // Filter key yang bukan merupakan URL dokumen
      if (
        !["_id", "id_pinjaman", "createdAt", "updatedAt", "__v"].includes(
          key,
        ) &&
        value
      ) {
        tmp.push({
          key: key,
          url: value,
        });
      }
    });
    setListUrlDokumen(tmp);
  }, [valDetail]);

  return (
    <Row className="mt-3">
      <Col md="12">
        <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
          <Card.Header className="bg-white border-0 pt-4 px-4">
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: "5px",
                  height: "20px",
                  backgroundColor: "#E63946",
                  borderRadius: "10px",
                  marginRight: "10px",
                }}
              />
              <h5 className="fw-800 text-dark mb-0">DOKUMEN NASABAH</h5>
            </div>
            <p className="text-muted small mt-1">
              Klik tombol "Lihat" untuk membuka pratinjau dokumen PDF.
            </p>
          </Card.Header>

          <Card.Body className="px-4 pb-4">
            <div
              style={{
                maxHeight: "550px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="custom-scrollbar pr-2"
            >
              <Row>
                {listUrlDokumen.length > 0 ? (
                  listUrlDokumen.map((val, index) => (
                    <Col md={6} key={index} className="mb-3">
                      <div
                        className="d-flex align-items-center p-3 border rounded shadow-sm hover-card"
                        style={{
                          transition: "all 0.3s",
                          backgroundColor: "#fcfcfc",
                        }}
                      >
                        {/* ICON PDF */}
                        <div
                          className="mr-3 text-danger d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            backgroundColor: "#fff5f5",
                            borderRadius: "10px",
                          }}
                        >
                          <i
                            className="far fa-file-pdf"
                            style={{ fontSize: "28px" }}
                          ></i>
                        </div>

                        {/* INFO DOKUMEN */}
                        <div className="flex-grow-1 overflow-hidden">
                          <h6
                            className="mb-0 fw-bold text-dark text-uppercase text-truncate"
                            style={{ fontSize: "12px" }}
                          >
                            {val.key.replace(/([A-Z])/g, " $1").trim()}
                          </h6>
                          <small
                            className="text-muted text-truncate d-block"
                            style={{ fontSize: "10px" }}
                          >
                            {val.url.split("/").pop()}
                          </small>
                        </div>

                        {/* ACTION BUTTON */}
                        <Button
                          variant="light"
                          className="ml-2 shadow-sm border-0"
                          style={{
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                          onClick={() => handleClickPdf(val.url)}
                        >
                          Lihat
                        </Button>
                      </div>
                    </Col>
                  ))
                ) : (
                  <Col md={12} className="text-center py-5 text-muted">
                    <i
                      className="far fa-folder-open mb-2"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <p>Tidak ada dokumen yang ditemukan.</p>
                  </Col>
                )}
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
        .fw-800 { font-weight: 800; }
        .hover-card:hover { 
          transform: translateY(-2px); 
          border-color: #E63946 !important; 
          background-color: #fff !important; 
        }
      `}</style>
    </Row>
  );
}

export default Step6;
